import React from "react";
import COLOURS from "util/colours";
import BonusOptionItem from "./bonus-option-item";
import { DiscordIcon, ThreadsIcon, TikTokIcon, XIcon, YouTubeIcon } from "./icons";

const bonusOptions = [
  {
    key: "linkShare",
    label: "Share With Friends",
    colour: COLOURS.seaGreen,
    icon: "fa-share-alt",
  },
  {
    key: "appDownload",
    label: "App Download",
    colour: COLOURS.seaGreen,
    icon: "fa-download",
  },
  {
    key: "fbLike",
    label: "Like on Facebook",
    colour: COLOURS.fbBlue,
    icon: "fa-facebook",
  },
  {
    key: "fbShare",
    label: "Share on Facebook",
    colour: COLOURS.fbBlue,
    icon: "fa-facebook",
  },
  {
    key: "instagramFollow",
    label: "Follow on Instagram",
    colour: COLOURS.instagramGradient,
    icon: "fa-instagram",
  },
  {
    key: "instagramVisit",
    label: "Visit Instagram Page",
    colour: COLOURS.instagramGradient,
    icon: "fa-instagram",
  },
  {
    key: "tiktokFollow",
    label: "Follow on TikTok",
    colour: COLOURS.tiktokAlt,
    //icon: "fa-tiktok",
    iconComponent: <TikTokIcon />,
    textWhite: true,
  },
  {
    key: "tiktokShare",
    label: "Share on TikTok",
    colour: COLOURS.tiktokAlt,
    //icon: "fa-tiktok",
    iconComponent: <TikTokIcon />,
    textWhite: true,
  },
  {
    key: "xFollow",
    label: "Follow on X",
    colour: COLOURS.xBlack,
    // icon: "fa-x-twitter",
    iconComponent: <XIcon />,
    textWhite: true,
  },
  {
    key: "xShare",
    label: "Share on X",
    colour: COLOURS.xBlack,
    // icon: "fa-x-twitter",
    iconComponent: <XIcon />,
    textWhite: true,
  },
  {
    key: "linkedinFollow",
    label: "Follow on LinkedIn",
    colour: COLOURS.linkedin,
    icon: "fa-linkedin",
  },
  {
    key: "linkedinShare",
    label: "Share on LinkedIn",
    colour: COLOURS.linkedin,
    icon: "fa-linkedin",
  },
  {
    key: "youtubeSubscribe",
    label: "YouTube Subscribe",
    colour: COLOURS.youtubeRed,
    // icon: "fa-youtube",
    iconComponent: <YouTubeIcon />,
  },
  {
    key: "youtubeWatch",
    label: "YouTube Watch Video",
    colour: COLOURS.youtubeRed,
    // icon: "fa-youtube",
    iconComponent: <YouTubeIcon />,
  },
  {
    key: "pinterestFollow",
    label: "Follow on Pinterest",
    colour: COLOURS.pinterestRed,
    icon: "fa-pinterest",
  },
  {
    key: "pinterestPin",
    label: "Pin on Pinterest",
    colour: COLOURS.pinterestRed,
    icon: "fa-pinterest",
  },
  {
    key: "snapchatFollow",
    label: "Follow on Snapchat",
    colour: COLOURS.snapchatYellow,
    icon: "fa-snapchat",
  },
  {
    key: "whatsappShare",
    label: "Share on WhatsApp",
    colour: COLOURS.whatsapp,
    icon: "fa-whatsapp",
  },
  {
    key: "discordJoin",
    label: "Join Discord Server",
    colour: COLOURS.discord,
    //icon: "fa-discord",
    iconComponent: <DiscordIcon />,
  },
  {
    key: "twitchFollow",
    label: "Follow on Twitch",
    colour: COLOURS.twitch,
    icon: "fa-twitch",
  },
  {
    key: "threadsFollow",
    label: "Follow on Threads",
    colour: COLOURS.threads,
    // icon: "fa-threads",
    iconComponent: <ThreadsIcon />,
    textWhite: true,
  },
];

/**
 * BonusOptions component for displaying bonus options
 * @param {Object} props - Component properties
 * @param {Object} props.currentBrand - The current brand object
 * @param {Object} props.partnershipInvite - The partnership invite object
 * @param {Object} props.bonusItems - Bonus items associated with the partnership invite
 * @param {Function} props.addBonusItem - Function to add a bonus item
 * @returns
 */
export default function BonusOptions(props) {
  const { currentBrand, partnershipInvite, bonusItems, addBonusItem } = props;

  const impersonating = sessionStorage.getItem("impersonating");
  const houseBrands = [52, 3, 65, 469, 305, 467, 468, 851, 514, 721];

  const createdItems = bonusItems.presentationOrder.map((item) =>
    item.partnership_invite_id === partnershipInvite.id ? item.bonus_type : null,
  );

  const bonusOptionItems = bonusOptions.map((item, idx) => {
    if (
      !houseBrands.includes(currentBrand.id) &&
      createdItems.includes(item.key) &&
      (!impersonating || impersonating === "null")
    ) {
      return null;
    }

    return (
      <BonusOptionItem
        key={idx}
        item={item}
        addBonusItem={addBonusItem}
        currentBrand={currentBrand}
      />
    );
  });

  return <div id="bonusOptions">{bonusOptionItems}</div>;
}
